
  import { Vue, Component, Prop } from "vue-property-decorator";

  @Component
  export default class FormTextarea extends Vue {
    @Prop({ type: String, default: undefined }) value?: string;
    @Prop({ type: String, default: undefined }) placeholder?: string;
    @Prop({ type: String, default: undefined }) name?: string;
    @Prop({ type: String, default: "" }) customBorderClass?: string;
    @Prop({ type: Number, default: 5 }) readonly rows!: number;
    @Prop({ type: Boolean, default: false }) invalid!: boolean;
    @Prop({ type: Boolean, default: false }) disabled!: boolean;

    get styles() {
      return {
        "block w-full border transition duration-150 ease-in-out sm:text-sm disabled:bg-gray-200 focus:outline-none resize-none p-2": true,
        "border-red-300 placeholder-red-300 focus:border-red-300": this.invalid,
        "focus:border-primary": !this.invalid,
        "rounded": !this.customBorderClass,
        "rounded-custom": this.customBorderClass,
        "bg-gray-200": this.disabled,
      }
    }

    handleInput(event: any) {
      this.$emit("input", event.target.value, event);
    };
  }
